<template>
  <div id="data-view">
    <div class="container">
      <div class="main-header">
        <!-- <div class="background" @click="backdeBtn">后台管理</div> -->
        <div class="kshWeather">
          <div class="weather-info">
            <!-- <i class="weather-icon">☀️</i>
            <span class="weather-temp">{{ weather.temperature }}°C</span>
            <span class="weather-desc">{{ weather.description }}</span> -->
            <div class="background" @click="backdeBtn">后台管理</div>
          </div>
        </div>
        <dv-decoration-4 :reverse="true" style="width:40%;height:5px;" />
            <li class="title">
              <dv-decoration-7 style="width:400px;height:30px;"><span>水务可视化</span></dv-decoration-7>
            </li>
            <dv-decoration-4 :reverse="true" style="width:40%;height:5px;" />
            <div class="kshTime">
              <div class="time-info">
                <div class="time-date">{{ currentTime.date }}</div>
                <div class="time-clock">{{ currentTime.time }}</div>
              </div>
            </div>
      </div>
      <dv-border-box-10 class="main-container">
        <!-- 左边的容器 -->
        <div class="left-container">
          <div style="height: 30%;">
            <Left1/>
            </div>
            <!-- <dv-decoration-4 :reverse="true" style="width:100%;height:0px;" /> -->
            <div class="left-container-module">
              <Left2/>
            </div>
            <dv-decoration-4 :reverse="true" style="width:100%;height:0px;" />
            <div class="left-container-module">
              <Left3/>
            </div>
            <!-- <dv-decoration-4 :reverse="true" style="width:100%;height:0px;" /> -->
            <div class="left-container-module">
              <Left4/>
            </div>
        </div>
        <!-- 中间的容器 -->
        <div class="middle-container">
          <div class="middle-container-module">
            <!-- 地图模块 -->
            <div class="baidumap">
              <Top2/>
            </div>
            <!-- 漏损模块 -->
            <div class="lousun">
            <Lsfx/>
            </div>
          </div>
          <div class="middle-container-modulew">
            <!-- 用量信息模块 -->
            <div class="yongliangxinxi">
              <RightBottom1/>
            </div>
            <!-- 区域统计模块 -->
            <div class="quyutongji">
              <rightBottom2/>
            </div>
          </div>
        </div>
        <!-- 右边的容器 -->
        <!-- <div class="right-container">
            <div class="right-container-module">
            <Right1/>
            </div>
          <div class="right-container-module"></div>
        </div> -->
         <!-- <dv-border-box-8 :reverse="true" class="top-box">
          <dv-border-box-12 class="Topbox-chart-1">
            <Top1/>
          </dv-border-box-12>
          <dv-border-box-12 class="Topbox-chart-2">
            <Top2/>
          </dv-border-box-12>
          <dv-border-box-12 class="Topbox-chart-3">
            <Top3/>
          </dv-border-box-12>
         </dv-border-box-8>
        <dv-border-box-8 :reverse="true" class="bottom-box">
          <dv-border-box-12 class="Bottombox-chart-1">
            <Bottom1/>
          </dv-border-box-12>
          <dv-border-box-12 class="Bottombox-chart-2">
            <Bottom2/>
          </dv-border-box-12>
          <dv-border-box-12 class="Bottombox-chart-3">
            <Bottom3/>
          </dv-border-box-12>
        </dv-border-box-8> -->
      </dv-border-box-10>
    </div>
  </div>
</template>

<script>
import Left1 from './left1'
import Right1 from './right1'// 老版漏损分析
import Lsfx from './lsfx'// 漏损分析
import Left2 from './left2'
import Left3 from './left3'
import Left4 from './left4'
import Top1 from './top1'
import Top2 from './top2'
import Top3 from './top3'
import Bottom1 from './Bottom1'
import Bottom2 from './Bottom2'
import Bottom3 from './Bottom3'

import RightBottom1 from './rightBottom1'
import RightBottom2 from './rightBottom2'
// import LeftChart2 from './LeftChart2'
// import LeftChart3 from './LeftChart3'

// import CenterCmp from './CenterCmp'

// import RightChart1 from './RightChart1'
// import RightChart2 from './RightChart2'

// import BottomCharts from './BottomCharts'

export default {
  name: 'DataView',
  components: {
    Left1,
    Left2,
    Left3,
    Left4,
    Right1,
    Lsfx,
    Top1,
    Top2,
    Top3,
    Bottom1,
    Bottom2,
    Bottom3,
    RightBottom1,
    RightBottom2
  },
  data () {
    return {
      currentTime: {
        date: '',
        time: ''
      },
      weather: {
        temperature: 22,
        description: '晴',
        icon: '☀️'
      },
      timeTimer: null
    }
  },
  mounted () {
    this.updateTime()
    this.timeTimer = setInterval(() => {
      this.updateTime()
    }, 1000)
    this.fetchWeather()
  },
  beforeDestroy () {
    if (this.timeTimer) {
      clearInterval(this.timeTimer)
    }
  },
  methods: {
    backdeBtn () {
      this.$router.push('/users')
    },
    updateTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekday = weekdays[now.getDay()]
      
      this.currentTime.date = `${year}-${month}-${day} ${weekday}`
      
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.currentTime.time = `${hours}:${minutes}:${seconds}`
    },
    async fetchWeather () {
      // 这里可以调用天气API，目前使用模拟数据
      // 如果需要真实天气数据，可以使用免费的天气API，如：
      // - OpenWeatherMap (需要API key)
      // - 和风天气 (需要API key)
      // - 高德天气API (需要API key)
      
      // 模拟天气数据，实际项目中应该调用API
      try {
        // const response = await this.$api.weather.getWeather()
        // this.weather = response.data
        this.weather = {
          temperature: 22,
          description: '晴',
          icon: '☀️'
        }
      } catch (error) {
        console.error('获取天气信息失败:', error)
        // 使用默认值
        this.weather = {
          temperature: 22,
          description: '晴',
          icon: '☀️'
        }
      }
    }
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  cursor: pointer;
  color: #fff;
  .container {
    height: 100vh;
    background-image: url('./img/bg.837e99ea.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-header {
    height: 80px;
    display: flex;
    justify-content:space-between;
    align-items:center;
    position: relative;
    .background{
      position: absolute;
      // bottom: 2px;
      left: 30px;
      padding: 4px 8px;
      font-size: 14px;
      color: #df9d10;
      background-color:  rgba(0, 119, 255, 0.3);
    }
    .kshWeather {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 150px;
      .weather-info {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #fff;
        font-size: 14px;
        .weather-icon {
          font-size: 20px;
          line-height: 1;
        }
        .weather-temp {
          font-weight: bold;
          color: #19ffe0;
          font-size: 16px;
        }
        .weather-desc {
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .kshTime {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 200px;
      .time-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        .time-date {
          font-size: 12px;
          color: #19ffe0;
          margin-bottom: 4px;
        }
        .time-clock {
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          font-family: 'Arial', sans-serif;
          letter-spacing: 2px;
        }
      }
    }
   .title{
      list-style: none;
      span{
        margin: 0 12px;
        font-size: 28px;
        font-weight: bold;
      }
    }
    .mh-left {
      font-size: 20px;
      color: rgb(1,134,187);

      a:visited {
        color: rgb(1,134,187);
      }
    }

    .mh-middle {
      font-size: 30px;
    }
  }

  .main-container {
    height: calc(~"100% - 80px");
    .border-box-content {
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
    }


.left-container{
  width: 35%;
  height: 100%;
  // background-color: #fff;
  .left-container-module{
    width: 100%;
    height: 22%;
    // border: 1px solid #000000;
  }
}
.middle-container{
  width: 65%;
  height: 100%;
  .middle-container-module{
    width: 100%;
    height: 50%;
    display: flex;
    // border: 1px solid #000000;
    .baidumap{
      width: 55%;
      height: 100%;
      // border: 1px solid #000000;
    }
    .lousun{
      width: 45%;
      height: 100%;
      // border: 1px solid #e2e0e0;
    }
  }
  .middle-container-modulew{
    width: 100%;
    height: 50%;
    display: flex;
    // border: 1px solid #969696;
    .yongliangxinxi{
      width: 50%;
      height: 100%;
      // border: 1px solid #000000;
    }
    .quyutongji{
      width: 50%;
      height: 100%;
      // border: 1px solid #000000;
    }
  }
}
.right-container{
  width: 25%;
  height: 100%;
  background-color: #0a0303;
  .right-container-module{
    width: 100%;
    height: 50%;
    border: 1px solid #969696;
  }
}



    .top-box{
      width: 100%;
      height: 60%;
      display: flex;
      .Topbox-chart-1{
        width: 25%;
      }
      .Topbox-chart-2{
        width: 50%;
      }
      .Topbox-chart-3{
        width: 25%;
      }
    }
    .bottom-box{
      width: 100%;
      height: 40%;
      .Bottombox-chart-1{
        width: 25%;
      }
      .Bottombox-chart-2{
        width: 25%;
      }
      .Bottombox-chart-3{
        width: 50%;
      }
    }
  }

   // 添加响应式布局
  @media screen and (max-width: 768px) {
    .container {
      height: auto;
      padding: 10px;
    }

    .main-container .border-box-content {
      flex-direction: column;
    }

    .left-chart-container,
    .right-main-container {
      width: 100% !important;
      margin-bottom: 10px;
    }

    .rmc-top-container {
      flex-direction: column;
    }

    .rmctc-left-container,
    .rmctc-right-container {
      width: 100% !important;
      margin-bottom: 10px;
    }
    .rmctc-chart-1, .rmctc-chart-2 {
      height: 80%;
      margin-top: 10px;
    }

    .main-header {
      height: 60px;
      .title span {
        font-size: 20px !important;
      }
      .background {
        font-size: 12px !important;
      }
    }
  }

  // 添加平板端适配
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .container {
      padding: 15px;
    }

    .left-chart-container {
      width: 30% !important;
    }

    .right-main-container {
      width: 70% !important;
    }

    .rmctc-left-container {
      width: 60% !important;
    }

    .rmctc-right-container {
      width: 40% !important;
    }

    .main-header .title span {
      font-size: 24px !important;
    }
  }
}
</style>
